import React from 'react';
import Icon from '../../../components/AppIcon';

const FailedIcon = () => {
  return (
    <div className="flex justify-center mb-6 md:mb-8">
      <div className="relative">
        <div className="absolute inset-0 bg-red-400 opacity-20 rounded-full animate-ping" />
        <div className="relative inline-flex items-center justify-center bg-gradient-to-r from-red-500 to-rose-500 rounded-full p-6 md:p-8 lg:p-10 shadow-lg">
          <Icon
            name="XCircle"
            size={48}
            color="#ffffff"
            className="md:w-16 md:h-16 lg:w-20 lg:h-20"
          />
        </div>
      </div>
    </div>
  );
};

export default FailedIcon;
